// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 35px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: rgb(33, 33, 38, 0.15);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Style Header - start */

/* font-family: "courier-prime",
monospace;
font-weight: 400;
font-style: normal; */

/* font-family: "courier-prime",
monospace;
font-weight: 400;
font-style: italic; */

/* font-family: "courier-prime",
monospace;
font-weight: 700;
font-style: normal; */

/* font-family: "courier-prime",
monospace;
font-weight: 700;
font-style: italic; */

header {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

header h1 {
  font-family: "permanent-marker", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;

  color: #F2C53D;
  -webkit-text-stroke: 1px #402A0F;

  width: 100%;
  text-align: right;
  border-bottom: 1px solid black;

  margin: 0;
}

nav ul {
  margin: 5px 0 0 0;
  padding: 0;
}

nav ul li {
  list-style-type: none;
  padding: 0;
  font-family: "courier-prime", monospace;
  font-weight: 400;
  font-style: normal;
}

/* Style Header - end */

/* Add new workout button - start */

div.workout-button-container {
  width: 100%;
}

div.workout-button-container button {

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  width: 250px;
  height: 40px;

  background-color: rgb(242, 230, 206, 0.8);

  border: 3px solid rgb(242, 197, 61);
  border-radius: 10px;

  font-family: "courier-prime",
    monospace;
  font-weight: 700;
  font-style: normal;
}

div.workout-button-container button:hover {

  background-color: rgb(242, 197, 61, 0.8);
  ;
}


/* Add new workout button - end */

/* Workout card - start */

div.workout-cards-area {
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  margin: 30px 0 30px 0;
}

div.workout-card {
  width: 600px;
  height: auto;

  background-color: rgb(255, 255, 255, 0.5);
  border: 2px solid rgb(242, 197, 61);
  border-radius: 10px;

  margin-top: 10px;
  margin-bottom: 10px;

  padding: 10px;
}

div.workout-card-heading {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

div.workout-card input {
  margin: 0;
  font-family: "courier-prime", monospace;
  font-weight: 700;
  font-style: normal;

  background: none;
  border: none;
  outline: none;

  font-size: 24px;
}

div.workout-card ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin: 0;
  padding: 0;
}

div.workout-card ul li {
  list-style-type: none;
  padding: 0;
  font-family: "courier-prime", monospace;
  font-weight: 400;
  font-style: normal;

  width: 90px;
  text-align: center;

  font-size: 16px;
}

div.workout-card ul li.exercise {
  width: 225px;
}

div.exercise-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

div.exercise-tab {
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background-color: white;
  border-radius: 10px;

  padding: 0;
  margin: 3px 0 2px 0;
}

div.exercise-tab input {
  font-family: "courier-prime", monospace;
  font-weight: 400;
  font-style: normal;

  width: 90px;
  text-align: center;

  font-size: 14px;

  margin: 5px 0 5px 0;

  background: none;
  border: none;
  outline: none;
}

div.exercise-tab input.exercise-tab {
  width: 225px;
}

button.add-exercise-button-area {
  margin: 20px 5px 0px 5px;
  float: right;

}

button.exercise-delete-button {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 0 5px 0 5px;
}

button.exercise-delete-button svg {
  fill: rgb(255, 0, 0, 0.3);
}


/* Workout card - end */

/* Login - start */
div.sign-up-login-container {
  height: 45vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-start;
  margin: 5rem 0 0 0;
}

div.login-container {

  /* height: 60vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


}

div.login-container h2 {
  font-family: "permanent-marker", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;

  color: #F2C53D;
  color: black;
  -webkit-text-stroke: 1px #402A0F;

  margin: 0;
}

div.login-container form {

  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;

  display: flex;
  flex-direction: column;
}

div.login-container form button {
  margin-top: 15px;

  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;
}

/* Login-end */

/* Sign up-start */
div.login-container {

  /* height: 60vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;


}

div.sign-up-container h2 {
  font-family: "permanent-marker", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;

  color: #F2C53D;
  color: black;
  -webkit-text-stroke: 1px #402A0F;

  margin: 0;
}

div.sign-up-container form {

  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;

  display: flex;
  flex-direction: column;
}

div.sign-up-container form button {
  margin-top: 15px;

  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;
}

p.comment {
  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;

  font-size: 14px;

  color: rgb(255, 0, 0, 0.5);
}

/* Sign up-end */

/* example - start */

div.example p {
  font-family: "courier-prime",
    monospace;
  font-weight: 400;
  font-style: normal;
  color: black;
  margin: 0;
}

/* example - end */

@media (max-width: 525px) {

  body {
    margin: 10px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    background-color: rgb(33, 33, 38, 0.15);
  }


  div.main-page-container {
    height: 90vh;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  div.workout-card {
    width: 350px;
    height: auto;

    background-color: rgb(255, 255, 255, 0.5);
    border: 2px solid rgb(242, 197, 61);
    border-radius: 10px;

    margin-top: 10px;
    margin-bottom: 10px;

    padding: 10px;
  }

  div.workout-card ul li.exercise {
    width: 100px;
  }

  div.exercise-tab input.exercise-tab {
    width: 130px;
  }

  div.workout-card input {
    margin: 0;
    font-family: "courier-prime", monospace;
    font-weight: 700;
    font-style: normal;

    background: none;
    border: none;
    outline: none;

    font-size: 16px;
  }

  div.workout-card ul li {
    list-style-type: none;
    padding: 0;
    font-family: "courier-prime", monospace;
    font-weight: 400;
    font-style: normal;

    width: 90px;
    text-align: center;

    font-size: 14px;
  }

  div.exercise-tab input {
    font-family: "courier-prime", monospace;
    font-weight: 400;
    font-style: normal;

    width: 55px;
    text-align: center;

    font-size: 12px;

    margin: 5px 0 5px 0;

    background: none;
    border: none;
    outline: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;;EAElC,uCAAuC;AACzC;;AAEA;EACE;aACW;AACb;;AAEA,yBAAyB;;AAEzB;;;qBAGqB;;AAErB;;;qBAGqB;;AAErB;;;qBAGqB;;AAErB;;;qBAGqB;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,cAAc;EACd,gCAAgC;;EAEhC,WAAW;EACX,iBAAiB;EACjB,8BAA8B;;EAE9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB,mCAAmC;;AAEnC;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;;EAEZ,yCAAyC;;EAEzC,mCAAmC;EACnC,mBAAmB;;EAEnB;aACW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;;AAE1C;;;AAGA,iCAAiC;;AAEjC,yBAAyB;;AAEzB;EACE,WAAW;;EAEX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;;EAEnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;;EAEZ,yCAAyC;EACzC,mCAAmC;EACnC,mBAAmB;;EAEnB,gBAAgB;EAChB,mBAAmB;;EAEnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;;EAElB,gBAAgB;EAChB,YAAY;EACZ,aAAa;;EAEb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;;EAElB,WAAW;EACX,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;EAEnB,uBAAuB;EACvB,mBAAmB;;EAEnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;;EAElB,WAAW;EACX,kBAAkB;;EAElB,eAAe;;EAEf,mBAAmB;;EAEnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,uBAAuB;;AAEvB,kBAAkB;AAClB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;;AAGrB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,cAAc;EACd,YAAY;EACZ,gCAAgC;;EAEhC,SAAS;AACX;;AAEA;;EAEE;aACW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;;EAEhB;aACW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;;AAEd,kBAAkB;AAClB;;EAEE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;;AAGrB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,cAAc;EACd,YAAY;EACZ,gCAAgC;;EAEhC,SAAS;AACX;;AAEA;;EAEE;aACW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;;EAEhB;aACW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;aACW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,eAAe;;EAEf,0BAA0B;AAC5B;;AAEA,gBAAgB;;AAEhB,oBAAoB;;AAEpB;EACE;aACW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA,kBAAkB;;AAElB;;EAEE;IACE,YAAY;IACZ;;gBAEY;IACZ,mCAAmC;IACnC,kCAAkC;;IAElC,uCAAuC;EACzC;;;EAGA;IACE,YAAY;;IAEZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;EAEhC;;EAEA;IACE,YAAY;IACZ,YAAY;;IAEZ,yCAAyC;IACzC,mCAAmC;IACnC,mBAAmB;;IAEnB,gBAAgB;IAChB,mBAAmB;;IAEnB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;;IAElB,gBAAgB;IAChB,YAAY;IACZ,aAAa;;IAEb,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;;IAElB,WAAW;IACX,kBAAkB;;IAElB,eAAe;EACjB;;EAEA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;;IAElB,WAAW;IACX,kBAAkB;;IAElB,eAAe;;IAEf,mBAAmB;;IAEnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 35px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  background-color: rgb(33, 33, 38, 0.15);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Style Header - start */\n\n/* font-family: \"courier-prime\",\nmonospace;\nfont-weight: 400;\nfont-style: normal; */\n\n/* font-family: \"courier-prime\",\nmonospace;\nfont-weight: 400;\nfont-style: italic; */\n\n/* font-family: \"courier-prime\",\nmonospace;\nfont-weight: 700;\nfont-style: normal; */\n\n/* font-family: \"courier-prime\",\nmonospace;\nfont-weight: 700;\nfont-style: italic; */\n\nheader {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\nheader h1 {\n  font-family: \"permanent-marker\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 48px;\n\n  color: #F2C53D;\n  -webkit-text-stroke: 1px #402A0F;\n\n  width: 100%;\n  text-align: right;\n  border-bottom: 1px solid black;\n\n  margin: 0;\n}\n\nnav ul {\n  margin: 5px 0 0 0;\n  padding: 0;\n}\n\nnav ul li {\n  list-style-type: none;\n  padding: 0;\n  font-family: \"courier-prime\", monospace;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Style Header - end */\n\n/* Add new workout button - start */\n\ndiv.workout-button-container {\n  width: 100%;\n}\n\ndiv.workout-button-container button {\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n\n  width: 250px;\n  height: 40px;\n\n  background-color: rgb(242, 230, 206, 0.8);\n\n  border: 3px solid rgb(242, 197, 61);\n  border-radius: 10px;\n\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 700;\n  font-style: normal;\n}\n\ndiv.workout-button-container button:hover {\n\n  background-color: rgb(242, 197, 61, 0.8);\n  ;\n}\n\n\n/* Add new workout button - end */\n\n/* Workout card - start */\n\ndiv.workout-cards-area {\n  width: 100%;\n\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n\n  margin: 30px 0 30px 0;\n}\n\ndiv.workout-card {\n  width: 600px;\n  height: auto;\n\n  background-color: rgb(255, 255, 255, 0.5);\n  border: 2px solid rgb(242, 197, 61);\n  border-radius: 10px;\n\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  padding: 10px;\n}\n\ndiv.workout-card-heading {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\ndiv.workout-card input {\n  margin: 0;\n  font-family: \"courier-prime\", monospace;\n  font-weight: 700;\n  font-style: normal;\n\n  background: none;\n  border: none;\n  outline: none;\n\n  font-size: 24px;\n}\n\ndiv.workout-card ul {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  margin: 0;\n  padding: 0;\n}\n\ndiv.workout-card ul li {\n  list-style-type: none;\n  padding: 0;\n  font-family: \"courier-prime\", monospace;\n  font-weight: 400;\n  font-style: normal;\n\n  width: 90px;\n  text-align: center;\n\n  font-size: 16px;\n}\n\ndiv.workout-card ul li.exercise {\n  width: 225px;\n}\n\ndiv.exercise-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\ndiv.exercise-tab {\n  width: 100%;\n  height: auto;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  background-color: white;\n  border-radius: 10px;\n\n  padding: 0;\n  margin: 3px 0 2px 0;\n}\n\ndiv.exercise-tab input {\n  font-family: \"courier-prime\", monospace;\n  font-weight: 400;\n  font-style: normal;\n\n  width: 90px;\n  text-align: center;\n\n  font-size: 14px;\n\n  margin: 5px 0 5px 0;\n\n  background: none;\n  border: none;\n  outline: none;\n}\n\ndiv.exercise-tab input.exercise-tab {\n  width: 225px;\n}\n\nbutton.add-exercise-button-area {\n  margin: 20px 5px 0px 5px;\n  float: right;\n\n}\n\nbutton.exercise-delete-button {\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 5px 0 5px;\n}\n\nbutton.exercise-delete-button svg {\n  fill: rgb(255, 0, 0, 0.3);\n}\n\n\n/* Workout card - end */\n\n/* Login - start */\ndiv.sign-up-login-container {\n  height: 45vh;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  align-items: flex-start;\n  margin: 5rem 0 0 0;\n}\n\ndiv.login-container {\n\n  /* height: 60vh; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n\n}\n\ndiv.login-container h2 {\n  font-family: \"permanent-marker\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 48px;\n\n  color: #F2C53D;\n  color: black;\n  -webkit-text-stroke: 1px #402A0F;\n\n  margin: 0;\n}\n\ndiv.login-container form {\n\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n\n  display: flex;\n  flex-direction: column;\n}\n\ndiv.login-container form button {\n  margin-top: 15px;\n\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n}\n\n/* Login-end */\n\n/* Sign up-start */\ndiv.login-container {\n\n  /* height: 60vh; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n\n}\n\ndiv.sign-up-container h2 {\n  font-family: \"permanent-marker\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 48px;\n\n  color: #F2C53D;\n  color: black;\n  -webkit-text-stroke: 1px #402A0F;\n\n  margin: 0;\n}\n\ndiv.sign-up-container form {\n\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n\n  display: flex;\n  flex-direction: column;\n}\n\ndiv.sign-up-container form button {\n  margin-top: 15px;\n\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n}\n\np.comment {\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n\n  font-size: 14px;\n\n  color: rgb(255, 0, 0, 0.5);\n}\n\n/* Sign up-end */\n\n/* example - start */\n\ndiv.example p {\n  font-family: \"courier-prime\",\n    monospace;\n  font-weight: 400;\n  font-style: normal;\n  color: black;\n  margin: 0;\n}\n\n/* example - end */\n\n@media (max-width: 525px) {\n\n  body {\n    margin: 10px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    background-color: rgb(33, 33, 38, 0.15);\n  }\n\n\n  div.main-page-container {\n    height: 90vh;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n  }\n\n  div.workout-card {\n    width: 350px;\n    height: auto;\n\n    background-color: rgb(255, 255, 255, 0.5);\n    border: 2px solid rgb(242, 197, 61);\n    border-radius: 10px;\n\n    margin-top: 10px;\n    margin-bottom: 10px;\n\n    padding: 10px;\n  }\n\n  div.workout-card ul li.exercise {\n    width: 100px;\n  }\n\n  div.exercise-tab input.exercise-tab {\n    width: 130px;\n  }\n\n  div.workout-card input {\n    margin: 0;\n    font-family: \"courier-prime\", monospace;\n    font-weight: 700;\n    font-style: normal;\n\n    background: none;\n    border: none;\n    outline: none;\n\n    font-size: 16px;\n  }\n\n  div.workout-card ul li {\n    list-style-type: none;\n    padding: 0;\n    font-family: \"courier-prime\", monospace;\n    font-weight: 400;\n    font-style: normal;\n\n    width: 90px;\n    text-align: center;\n\n    font-size: 14px;\n  }\n\n  div.exercise-tab input {\n    font-family: \"courier-prime\", monospace;\n    font-weight: 400;\n    font-style: normal;\n\n    width: 55px;\n    text-align: center;\n\n    font-size: 12px;\n\n    margin: 5px 0 5px 0;\n\n    background: none;\n    border: none;\n    outline: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
